/**
 * @fileoverview Utilitários para detecção e otimização mobile.
 * Gerencia comportamentos específicos para dispositivos móveis.
 * 
 * @module MobileUtils
 * @since 1.0.0
 */

/**
 * Detecta se está rodando em Safari iOS.
 * @returns {boolean}
 */
export const isSafariIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && 
         /Safari/.test(navigator.userAgent) && 
         !/Chrome/.test(navigator.userAgent);
};

/**
 * Detecta se está rodando em dispositivo móvel.
 * @returns {boolean}
 */
export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

/**
 * Gerenciador de visibilidade da página para otimizar conexões.
 */
export const visibilityManager = {
  listeners: new Set(),
  currentState: document.visibilityState,

  /**
   * Adiciona listener para mudanças de visibilidade.
   * @param {Function} callback
   */
  addListener: (callback) => {
    visibilityManager.listeners.add(callback);
    if (visibilityManager.listeners.size === 1) {
      document.addEventListener('visibilitychange', visibilityManager.handleChange);
    }
  },

  /**
   * Remove listener de visibilidade.
   * @param {Function} callback
   */
  removeListener: (callback) => {
    visibilityManager.listeners.delete(callback);
    if (visibilityManager.listeners.size === 0) {
      document.removeEventListener('visibilitychange', visibilityManager.handleChange);
    }
  },

  /**
   * Manipula mudanças de visibilidade.
   */
  handleChange: () => {
    visibilityManager.currentState = document.visibilityState;
    visibilityManager.listeners.forEach(callback => {
      try {
        callback(visibilityManager.currentState);
      } catch (error) {
        console.warn('Erro no callback de visibilidade:', error);
      }
    });
  }
};

/**
 * Configurações específicas para mobile.
 */
export const mobileConfig = {
  // Timeout reduzido para mobile
  requestTimeout: isMobile() ? 10000 : 30000,
  
  // Intervalo de retry para reconexão
  retryInterval: isMobile() ? 3000 : 1000,
  
  // Máximo de tentativas de reconexão
  maxRetries: isMobile() ? 3 : 5,
  
  // Usar polling em vez de WebSocket em Safari iOS
  usePolling: isSafariIOS()
};

export default {
  isSafariIOS,
  isMobile,
  visibilityManager,
  mobileConfig
};